import { memo } from 'react';
import { Box, Button, Text, theme } from '@frameio/vapor';
import { IconWarningFill } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/LoadingMoreIndicatorError';

TEXT.DEFINE({
  /** Error message when loading more notifications fails */
  fetchMoreError: 'Failed to load more notifications',
  /** Button label to reload the page */
  reload: 'Reload',
});

type LoadingMoreIndicatorErrorProps = {
  onClick?: () => void;
};

export const LoadingMoreIndicatorError = memo(
  function LoadingMoreIndicatorError({
    onClick = () => window.location.reload(),
  }: LoadingMoreIndicatorErrorProps) {
    return (
      <Box
        alignItems="center"
        display="flex"
        height="105px"
        justifyContent="center"
      >
        <IconWarningFill aria-label={TEXT.fetchMoreError} />

        <Text
          color="tertiary"
          style={{
            marginLeft: `${theme.spaces[8]}`,
            marginRight: `${theme.spaces[24]}`,
          }}
          variant="secondary"
        >
          {TEXT.fetchMoreError}
        </Text>
        <Button onClick={onClick} variant="link">
          {TEXT.reload}
        </Button>
      </Box>
    );
  }
);
